<template>
    <dx-check-box :value="checkbox" text="Текущие записи" @value-changed="onValueChange" />
    <ai-tree-list-edit
        :meta="meta"
        :args="args"
        ref="treeListRef"
        :toRemoveToolbarItemsNames="[
            'choice',
            'moveSave',
            'moveTo',
            'copy',
            'edit',
            'addSibling',
            'addChild',
            'delete',
            'save',
        ]"
    />
</template>

<script setup>
import AiTreeListEdit from '@/components/ai-tree-list-edit/ai-tree-list-edit.vue';
import { DxCheckBox } from 'devextreme-vue/check-box';
import { onMounted, ref, watch } from 'vue';
import { mainState } from '@/layouts/main-layout/main-layout-data';

const checkbox = ref(true);
const treeListRef = ref();
const meta = {
    keyExpr: 'kod_fs',
    title: 'ОКОПФ',
    rights: {},
    columns: [
        {
            name: 'abbr',
            caption: 'Код ОКОПФ',
            dataField: 'abbr',
            allowEditing: false,
            editor: {
                type: 'default',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 200,
            minWidth: 200,
            index: 1,
            visible: true,
        },
        {
            name: 'kod_fs',
            caption: 'kod_fs',
            dataField: 'kod_fs',
            allowEditing: false,
            editor: {
                type: 'default',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 81,
            index: 6,
            visible: false,
        },
        {
            name: 'name',
            caption: 'Наименование',
            dataField: 'name',
            allowEditing: false,
            editor: {
                type: 'default',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 500,
            index: 2,
            visible: true,
        },
        {
            name: 'abbr_new',
            caption: 'Аббревиатура',
            dataField: 'abbr_new',
            allowEditing: false,
            editor: {
                type: 'default',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 200,
            index: 3,
            visible: true,
        },
        {
            name: 'ur_lico',
            caption: 'Юр. лицо',
            dataField: 'ur_lico',
            allowEditing: false,
            editor: {
                type: 'default',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 200,
            index: 4,
            visible: true,
            dataType: 'boolean',
        },
        {
            name: 'arhive',
            caption: 'Архив',
            dataField: 'arhive',
            allowEditing: false,
            editor: {
                type: 'default',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 200,
            index: 5,
            visible: true,
            dataType: 'boolean',
        },
        {
            name: 'kod_parent',
            caption: 'kod_parent',
            dataField: 'kod_parent',
            allowEditing: false,
            editor: {
                type: 'default',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 57,
            index: 7,
            visible: false,
        },
    ],
    api: {
        select: 'nsi./nsi/view-ks-fs/select/get',
    },
    viewId: 'ks-fs-view',
    parentIdExpr: 'kod_parent',
};
const args = {
    select: {
        select_args: {
            select_arg: checkbox.value,
        },
    },
};

onMounted(async () => {
    await treeListRef.value.setCacheOrApiDataSource();
});

watch(
    () => mainState.routePath,
    async () => {
        await treeListRef.value.setCacheOrApiDataSource();
    }
);

const onValueChange = async e => {
    checkbox.value = e.value;
    args.select.select_args.select_arg = e.value;

    await treeListRef.value.setDataSource();
};
</script>

<script>
export default {
    name: 'ks-fs-view',
};
</script>

<style scoped></style>
